/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { useParams, Link } from "react-router-dom";
import {
  ResponsiveWidget,
  ResponsiveWidgetItem,
} from "../../components/ResponsiveWidget";
import {
  portalWorkingWaysHeading,
  portalWorkingWays,
  PropValuesEnum,
  color,
  routeURL,
  getPageTitle,
  getPartnerSpecificImage,
  getPartnerSpecificBckClr,
  getPartnerProfession,
  joinUsNowText,
  getPartnerPageDescription,
  buttonActions,
  GAEvents,
} from "../../constants/commons";

import { partnerStyle, sidebarBackground } from "./styles";
import { responsiveStyles, singleSectionStyles } from "../../commons/styles";

import { useIsMobile, useIsTab } from "../../hooks/useIsMobile";
import { SignUpModal } from "../../modals/SignUpModal";
import { PartnersSpeak } from "../../components/PartnersSpeak";
import { FeesGuidelines } from "../../components/FeesGuidelines";
import { JoiningSteps } from "../../components/JoiningSteps";
import backIcon from "../../assets/back-arrow.svg";
import { FAQ, FAQCategoryEnum } from "../../components/FAQ";
import { CustomButton } from "../../atoms/CustomButton";
import {
  CustomButtonColor,
  CustomButtonTypes,
} from "../../atoms/CustomButton/interface";
import { GA_Event } from "../../utils/reactGA";
interface IPartnersProps {}

export const Partners: React.FC<IPartnersProps> = (props: IPartnersProps) => {
  const { partnerID } = useParams() as any;
  const isMobile = useIsMobile();
  const isTablet = useIsTab();

  const [modalType, setmodalType] = React.useState<string>();
  // State for maintaining the state of modal
  const [openSignUpModal, setOpenSignUpModal] = React.useState<boolean>(false);
  const onButtonClickAction = (clickType: string) => {
    setmodalType(clickType);
    setOpenSignUpModal(true);
  };

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getPortalWorkingWays = () => {
    return portalWorkingWays.map((item, key) => {
      return (
        <ResponsiveWidgetItem key={key}>
          <img src={require(`../../assets/${item.icon}`)} alt="" />
          <div>{item.description}</div>
        </ResponsiveWidgetItem>
      );
    });
  };

  const handleCancelModal = () => {
    setOpenSignUpModal(false);
  };

  const responsiveVideoCarousel = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1670 },
      items: 1,
      partialVisibilityGutter: 100,
    },
    desktop: {
      breakpoint: { max: 1670, min: 1170 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    smallDesktop: {
      breakpoint: { max: 1170, min: 885 },
      items: 1,
      partialVisibilityGutter: 20,
    },
  };

  return (
    <span css={[responsiveStyles, partnerStyle]}>
      {openSignUpModal && (
        <SignUpModal
          visible={openSignUpModal}
          handleCancel={handleCancelModal}
          modalType={modalType}
        />
      )}

      <div className="container-fluid partner-header partnerspecific-padding-container">
        <div
          className={`row bg-white ${
            isMobile ? "" : "pt-2 variable-margin-style"
          }`}
        >
          <div
            css={sidebarBackground(getPartnerSpecificBckClr(partnerID))}
            className={`col-sm-3 col-12 ${
              isMobile ? "responsive-margin-container p-0" : "sticky-container "
            }`}
          >
            <div className="col responsive-landing-header-left d-none d-sm-block pt-5 p-0">
              Make an impact on world with Cult.fit
            </div>
            <img
              src={getPartnerSpecificImage(partnerID)}
              alt={getPageTitle(partnerID)}
              className="responsive-image-header"
            />
          </div>
          <div
            className={`col-sm-9 col-12 ${
              isMobile ? "mt-4" : "partner-padding-style"
            }`}
          >
            <div className="d-sm-flex align-items-center mb-3 d-none d-sm-block ">
              <Link
                to={routeURL.landingPage}
                className="d-flex align-items-center back-button-style"
              >
                <button className="border-0 bg-white user-button-style">
                  <img src={backIcon} alt="" />
                </button>
                <div className="ml-1 back-button-style ">Back</div>
              </Link>
            </div>

            <div
              className={`row justify-content-between align-items-center ${
                isTablet ? "mt-4" : ""
              }`}
            >
              <div className="d-flex">
                <div className="responsive-partner-heading-right px-3">
                  {getPageTitle(partnerID)}
                </div>
              </div>
            </div>
            <div className="responsive-description col-12 p-0 col-lg-10">
              {getPartnerPageDescription(partnerID)}
            </div>
            <div className="single-section p-0" css={singleSectionStyles()}>
              <div className="header-container mb-4">
                <h5>{portalWorkingWaysHeading}</h5>
              </div>
              <ResponsiveWidget align={PropValuesEnum.VERTICAL}>
                {getPortalWorkingWays()}
              </ResponsiveWidget>
            </div>
            <div className="single-section p-0" css={singleSectionStyles()}>
              <PartnersSpeak
                cardBgColor={color.whitishGray}
                carouselViewBreakpoints={responsiveVideoCarousel}
                profession={getPartnerProfession(partnerID) || ""}
              />
            </div>
            {/* <div className="single-section p-0" css={singleSectionStyles}>
              <CfBlogList />
            </div> */}
            <div
              className={`single-section py-0 ${
                isMobile ? "p-0" : "pl-0 pr-5"
              }`}
              css={singleSectionStyles(color.white)}
            >
              <FeesGuidelines profession={getPartnerProfession(partnerID)} />
            </div>
            <div
              className="single-section p-0"
              css={singleSectionStyles(color.white)}
            >
              <JoiningSteps heading="Steps to join us" />
            </div>
            <div
              className={`single-section p-0 ${isMobile ? "" : "pr-5"}`}
              css={singleSectionStyles()}
            >
              <FAQ
                categories={[
                  FAQCategoryEnum.JOINING_PARTNER_FIT,
                  FAQCategoryEnum.SCHEDULING_CUSTOMER_SESSIONS,
                  FAQCategoryEnum.PAYMENTS,
                ]}
              />
            </div>
            {isMobile && (
              <div
                className={`single-section join-us-btn-container`}
                css={singleSectionStyles()}
              >
                <CustomButton
                  color={CustomButtonColor.PRIMARY}
                  type={CustomButtonTypes.BUTTON}
                  onClick={() => {
                    GA_Event(
                      GAEvents.JOIN_US_NOW,
                      "clicked",
                      `from Partners:${partnerID} page`
                    );
                    onButtonClickAction(buttonActions.SIGNUP);
                  }}
                >
                  {joinUsNowText}
                </CustomButton>
              </div>
            )}
          </div>
        </div>
      </div>
    </span>
  );
};
